import { connect } from 'react-redux';
import { GeneralEnterprise } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import {
    getSimpleUserEmail,
    getSimpleUserFullName,
    getSimpleUserImageId,
} from '@mews-commander/legacy-entities/src/ducks/simpleUsers';
import {
    getCurrentEnterpriseImageId as getCurrentEnterpriseImageIdJS,
    getCurrentEnterpriseName as getCurrentEnterpriseNameJS,
} from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { WithUserId } from '../../../../types';
import { UserProfileAvatarProps } from './UserProfileAvatar';

type CurrentEnterpriseSelector<K extends keyof GeneralEnterprise> = (
    state: ApplicationState
) => GeneralEnterprise[K] | undefined;
const getCurrentEnterpriseImageId =
    getCurrentEnterpriseImageIdJS as unknown as CurrentEnterpriseSelector<'logoImageId'>;
const getCurrentEnterpriseName = getCurrentEnterpriseNameJS as unknown as CurrentEnterpriseSelector<'name'>;

type StateProps = Pick<
    UserProfileAvatarProps,
    'enterpriseImageId' | 'enterpriseName' | 'userEmail' | 'userFullName' | 'userImageId'
>;

export default connect<StateProps, {}, WithUserId, ApplicationState>((state, { userId }) => ({
    enterpriseImageId: getCurrentEnterpriseImageId(state),
    enterpriseName: getCurrentEnterpriseName(state),
    userImageId: getSimpleUserImageId(state, { id: userId }),
    userFullName: getSimpleUserFullName(state, { id: userId }),
    userEmail: getSimpleUserEmail(state, { id: userId }),
}));
